<template>
  <div class="volume-discount-wrapper min-w-min border text-sm">
    <div class="w-full py-[5px] bg-EXPONDO-grey-5 flex justify-between">
      <div class="min-w-[50px] text-center">
        {{ $t('qty') }}
      </div>
      <div class="min-w-[50px] text-center">
        {{ $t('Discount') }}
      </div>
      <div class="min-w-[120px] text-center">
        {{ $t('Per item') }}
      </div>
    </div>
    <div
      class="w-full flex-col inline-flex bg-EXPONDO-white"
    >
      <VolumeDiscountRow
        v-for="(volumeDiscount) in volumeDiscounts"
        :key="volumeDiscount.volume"
        :final-price="finalPrice"
        :volume-discount="volumeDiscount"
        :loyalty-discount-percentage="loyaltyDiscountPercentage"
      />
    </div>
  </div>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import type { VolumeDiscount } from '~~/types/discounts';
import { isCheckoutDisabled } from '~~/helpers/Checkout/isCheckoutDisabled';
import { useLocalization } from '~/composables/useLocalization';

export default defineComponent({
  name: 'VolumeDiscount',
  props: {
    finalPrice: {
      type: Number,
      required: true,
    },
    volumeDiscounts: {
      type: Array as PropType<VolumeDiscount[]>,
      default: () => [],
    },
    stock: {
      type: Number,
      required: true,
    },
    loadingStocks: {
      type: Boolean,
      required: true,
    },
    productSku: {
      type: String as PropType<string | null>,
      required: false,
      default: null,
    },
    loyaltyDiscountPercentage: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {

    const { loadingStocks } = toRefs(props);
    const { countryCode } = useLocalization();

    const isInStock = computed(() => props.stock > 0);

    const canShowCustomQuoteSection = computed(() => {

      return !loadingStocks.value && isInStock.value && !isCheckoutDisabled(countryCode.value);

    });

    return {
      LINK_TYPE,
      canShowCustomQuoteSection,
    };

  },
});


</script>
